/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pearl_Tall_Rat_PurrInputs */

const en_pearl_tall_rat_purr = /** @type {(inputs: Pearl_Tall_Rat_PurrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace existing access rights`)
};

const de_pearl_tall_rat_purr = /** @type {(inputs: Pearl_Tall_Rat_PurrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestehende Rechte ersetzen`)
};

/**
* | output |
* | --- |
* | "Replace existing access rights" |
*
* @param {Pearl_Tall_Rat_PurrInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pearl_tall_rat_purr = /** @type {((inputs?: Pearl_Tall_Rat_PurrInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pearl_Tall_Rat_PurrInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pearl_tall_rat_purr(inputs)
	return de_pearl_tall_rat_purr(inputs)
});